import {useMemo} from 'react'

import {getUrlParams} from '../../_web/utils/url'
import {hasAudienceTokenInUrl} from '../../offer/business/privateDeals'

export const useIsAudience = () => {
  const urlParams = getUrlParams()
  return useMemo(() => hasAudienceTokenInUrl(urlParams), [urlParams?.token])
}
